import fetch from 'isomorphic-fetch'
import URLSearchParams from 'url-search-params'

export function createFetchVideoRequest(options) {
  var searchParams = new URLSearchParams()
  if (options.sort) {
    searchParams.append("sort", options.sort)
  }
  if (options.sortd) {
    searchParams.append("sortd", options.sortd)
  }
  if (options.count) {
    searchParams.append("count", options.count)
  }
  if (options.page) {
    searchParams.append("page", options.page)
  }
  if (options.group_id) {
    searchParams.append("group", options.group_id)
  }
  if (options.search) {
    searchParams.append("search", options.search)
  }
  if (options.tag) {
    searchParams.append("tag", options.tag)
  }
  if (options.trending) {
    searchParams.append("trending", options.trending)
  }

  return fetch(`${process.env.REACT_APP_API_HOST}/videos?` + searchParams.toString(), {
    credentials: 'include',
    headers: {
      'pragma': 'no-cache',
      'cache-control': 'no-cache',
    }
  })
  .then(response => response.json())
}